module.exports = __webpack_public_path__ + "img/Property List.0704ab77.svg";